import {RootState} from "../store";

export const selectEnvVariables = (state: RootState) => state.variables.variables;
